export default __webpack_public_path__ + "static/media/Amazonofferimage_730x490.636fb4d7.png";